import { Box, CircularProgress, createTheme, ThemeProvider } from "@mui/material";
import { blue } from "@mui/material/colors";
import Navbar from "./components/Navbar";
import { Route, Routes, useSearchParams } from "react-router-dom";
import zIndex from "@mui/material/styles/zIndex";
import BottomNav from "./components/BottomNav";
import Orders from "pages/Orders";
import Settings from "pages/Settings";
import Initial from "pages/Initial";
import { useSelector } from "react-redux";
import Landing from "pages/Landing";
import Addresses from "pages/Addresses";
import Cardapio from "pages/Cardapio";
import { useQueryShoppingBag } from "./services/api/queries/useQueryShoppingBag";
import useGuestLogin from "./components/useGuestLogin";
import { ICardapioAppState } from "./redux/RootReducer";
import React, { useEffect } from "react";
import { useQueryPlace } from "./services/api/queries/useQueryPlace";
import NotFound from "pages/NotFound";
import ElloDeliveryLogo from "./assets/svg/ElloDeliveryLogo.svg";

export default function App() {

  useGuestLogin();
  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);

  const [searchParams, setSearchParams] = useSearchParams();

  // definindo variáveis que serão usadas em outros componentes,
  // vamos buscar na query string da URL apenas aqui
  const placeId = searchParams.get("place_id");
  const table = searchParams.get("table");
  const customOriginQrCode = searchParams.get("origin");
  const whatsappIdentifier = searchParams.get("wani") ?? undefined;

  useEffect(() => {
    if (!placeId || !Number(placeId)) {
      const params = Object.fromEntries(searchParams.entries());
      params.place_id = "445057";
      setSearchParams(params);
    }
  }, [placeId, searchParams, setSearchParams]);

  const placeIdNumber = placeId && Number(placeId)
    ? Number(placeId)
    : 445057;

  // queries:
  const apiPlace = useQueryPlace(placeIdNumber);
  const shoppingBagQuery = useQueryShoppingBag(placeIdNumber,
    loginInfo,
    Number(table ?? 0),
    Number(customOriginQrCode ?? 0),
    whatsappIdentifier);

  if(apiPlace.isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="80vh"
        padding={2}
      >
        <Box mb={4}>
          <img
            src={ElloDeliveryLogo}
            alt="Ello Delivery Logo"
            style={{
              width: '200px',
              height: 'auto',
            }}
          />
        </Box>
        <CircularProgress />
      </Box>
    )
  }

  if (!apiPlace.data?.data || !apiPlace.data.data.active) {
    return <NotFound />;
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#FB6B1C",
      },
      secondary: {
        main: blue[300],
      },
    },
    zIndex: {
      appBar: zIndex.drawer + 1,
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <Navbar shoppingBagQuery={shoppingBagQuery} placeInfo={apiPlace?.data?.data} />
      <Routes>
        <Route path="/" element={<Landing shoppingBagQuery={shoppingBagQuery} />} />
        <Route path="/delivery" element={<Cardapio shoppingBagQuery={shoppingBagQuery} />} />
        <Route path="/cardapio" element={<Cardapio shoppingBagQuery={shoppingBagQuery} />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/settings" element={<Settings shoppingBagQuery={shoppingBagQuery} />} />
        <Route path="/login" element={<Initial />} />
        <Route path="/addresses" element={<Addresses shoppingBagQuery={shoppingBagQuery} />} />
      </Routes>
      <BottomNav shoppingBagQuery={shoppingBagQuery} />
    </ThemeProvider>
  );
}
